export default "53a6b73e5f8549c0.svg"